var $ = require('jquery');

(function ($) {
    $.validator.unobtrusive.adapters.addBool("enforcetrue");

    $.validator.addMethod("enforcetrue", function (value, element, params) {
        return element.checked;
    });

    //Add an adapter for our validator. This maps the data from the ModelClientValidationCompareStringsRule
    //we defined above, to the validation framework. Make sure to use the same name as we chose for the ValidationType property ("comparestrings")
    $.validator.unobtrusive.adapters.add("comparestrings", ["otherprop", "ignorecase"],
        function (options) {
            options.rules["comparestrings"] = {
                otherPropName: options.params.otherprop,
                ignoreCase: options.params.ignorecase === "true"
            };
            options.messages["comparestrings"] = options.message;
        });

    //Add the method, again using the "comparestrings" name, that actually performs the client-side validation to the page's validator
    $.validator.addMethod("comparestrings", function (value, element, params) {
        //element is the element we are validating and value is its value

        //Get the MVC-generated prefix of element
        //(E.G. "MyViewModel_" from id="MyViewModel_CompareEmail"
        var modelPrefix = getModelIDPrefix($(element).prop("id"));

        //otherPropName is just the name of the property but we need to find
        //its associated element to get its value. So concatenate element's
        //modelPrefix with the other property name to get the full MVC-generated ID. If your elements use your own, overridden IDs, you'd have to make some modifications to allow this code to find them.
        var $otherPropElem = $("#" + modelPrefix + params.otherPropName);

        var otherPropValue = getElemValue($otherPropElem);

        //Note: Logic for comparing strings needs to match what it does on the server side

        //Trim values
        value = $.trim(value);
        otherPropValue = $.trim(otherPropValue);

        //If ignoring case, lower both values
        if (params.ignoreCase) {
            value = value.toLowerCase();
            otherPropValue = otherPropValue.toLowerCase();
        }

        //compare the values
        var isMatch = value === otherPropValue;

        return isMatch;
    });

    function getElemValue(element) {
        var value;
        var $elem = $(element);

        //Probably wouldn't use checkboxes or radio buttons with
        //comparestrings, but this method can be used for other validators too
        if ($elem.is(":checkbox") || $elem.is(":radio") === "radio")
            value = $elem.prop("checked") ? "true" : "false";
        else
            value = $elem.val();

        return value;
    }
    $.validator.unobtrusive.adapters.add("checkboxtrue", ["propertyname"],
        function(options) {
            options.rules["checkboxtrue"] = {
                propName: options.params.propertyname
            };
            options.messages["checkboxtrue"] = options.message;
        });
    $.validator.addMethod("checkboxtrue", function (value, element, params) {
        var isCheckedTrue = (checkCheckBoxGroupOneTrue(element) === "true");
        return isCheckedTrue;
    });
    function checkCheckBoxGroupOneTrue(el) {
        var anyboxeschecked = "false";
        //check for inputs with the name which the validator has been attached too.
        $('input[name="' + el.name + '"]').each(function () {
            var isChecked = this.checked ? "true" : "false";
            if (isChecked === "true") {
                anyboxeschecked = "true";
                //return false to break out of loop
                return false;
            }
        });
        return anyboxeschecked;
    }
    //Gets the MVC-generated prefix for a field by returning the given string
    //up to and including the last underscore character
    function getModelIDPrefix(fieldID) {
        return fieldID.substr(0, fieldID.lastIndexOf("_") + 1);
    }
}($));